module.exports = __webpack_public_path__ + "files/fd67fb35731da39667ae210a98c60ef4.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size2-Regular.woff
 ** module id = 1071
 ** module chunks = 0
 **/